import { Enum  } from "./Enum";

export const ShippingMethodServiceEnum: Enum[] = [
  { id: 'regular', name: 'Regular' },
  { id: 'express', name: 'Express' },
];

export const OwnAccountShippingMethodServiceEnum: Enum[] = [
  { id: 'regular', name: 'Regular' },
  { id: 'express', name: 'Express' },
  { id: 'priority_overnight', name: 'Priority Overnight' },
  { id: 'overnight', name: 'Overnight' },
  { id: '2nd_day', name: '2nd Day' },
  { id: '3rd_day', name: '3rd Day' },
  { id: 'ground', name: 'Ground' },
];

export const OwnAccountEnum: Enum[] = [
  { id: 'bill_to_account', name: 'Bill to Account' },
  { id: 'ship_to_account', name: 'Ship to Account' },
];